
import React from "react";
import { User } from "@/lib/auth";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ProfileSettingsProps {
  user: User;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onChangePassword: () => void;
}

export const ProfileSettings: React.FC<ProfileSettingsProps> = ({
  user,
  open,
  onOpenChange,
  onChangePassword
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Paramètres du compte</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <h3 className="font-medium mb-2">Informations personnelles</h3>
            <p className="text-sm text-gray-600">Nom: {user.name}</p>
            <p className="text-sm text-gray-600">Pseudo: {user.nickname}</p>
            <p className="text-sm text-gray-600">Rôle: {user.role === "admin" ? "Administrateur" : "Ouvrier"}</p>
          </div>
          <div className="flex space-x-2">
            <Button 
              variant="outline" 
              onClick={onChangePassword}
              className="flex-1"
            >
              Changer le mot de passe
            </Button>
            <Button 
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1"
            >
              Fermer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
